module.exports = __webpack_public_path__ + "img/c.7119e899.jpg";